
// Integrations
exports.SAT_IMG = 'https://s3-us-west-2.amazonaws.com/porcobrar.com/assets/int_sat.png';
exports.INSTRUCTIONS_IMG = 'https://s3-us-west-2.amazonaws.com/porcobrar.com/assets/int_manual_payment.png';
exports.SPEI_IMG = 'https://s3-us-west-2.amazonaws.com/porcobrar.com/assets/int_spei.png';


// WEBPACK FOOTER //
// ./src/constants/assets.js